export const UPDATE_ISlOADING_ORDERS = 'update_isloading_orders';
export const UPDATE_ORDERS = 'update_orders';
export const UPDATE_TRACKINGID = 'update_trackingid';
export const OPEN_MODAL_CREATE_SHIPPING = 'open_modal_create_shipping';
export const SET_ORDER_TO_SHIPPING = 'set_order_to_shipping';
